export const timeDummyRoute = {
    path: "/timedummy",
    role: "Doer"
};
